import './App.css'
import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './component/Home'
import Services from './component/Services'
import Pricing from './component/Pricing'
import Faq from './component/Faq'
import Aboutus from './component/Aboutus'
import Header from './component/Header'
import { Order } from './component/Order'
import Demo from './component/Demo'
import Terms from './component/Terms'
import Privacy from './component/Privacy'
import Payment from './component/Payment'

function App () {
  const [payment, setPayment] = React.useState([])
  const [tomail,setToMail]=React.useState("")
  return (
    <div className='App'>
      <Router>
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/service' element={<Services />} />
          <Route path='/pricing' element={<Pricing />} />
          <Route path='/faq' element={<Faq />} />
          <Route path='/aboutus' element={<Aboutus />} />
          <Route
            path='/order'
            element={<Order payment={payment} setPayment={setPayment} setToMail={setToMail}  />}
          />
          <Route path='/demo' element={<Demo />} />
          <Route path='/terms' element={<Terms />} />
          <Route path='/privacypolicy' element={<Privacy />} />
          <Route path='/payment' element={<Payment payment={payment} tomail={tomail} />} />
          <Route />
        </Routes>
      </Router>
    </div>
  )
}

export default App
